"use_strict"

class Maps {

	constructor () {
		const wordpressThemeUrl = i18n.themeUrl;
		const $ = require('zepto-browserify').$;

		let mapConfig = {
			map: 'world_mill',
			backgroundColor: '#ffffff',
			zoomButtons: false,
			zoomOnScroll: false,
			series: {
	        	regions: [{
			        scale: {
			          producteur: '#777777',
			          acheteur: '#E60023'
			        },
			        attribute: 'fill'
			    }],
	        },
	        regionStyle: {
				initial: {
				    stroke: '#000000',
				    "stroke-width": 1,
				    "stroke-opacity": 0.2
				},
	        },
			onRegionTipShow: function (e, el, code) {
		       e.preventDefault();
		    },
		    onRegionOver: function (e, el, code) {
		       e.preventDefault();
		    }
		};

		$.getJSON( wordpressThemeUrl + '/pays-producteurs.json', function(data) {
			mapConfig.series.regions[0].values = data;
			$('#map-productors').vectorMap(mapConfig);
		});

		$.getJSON( wordpressThemeUrl + '/pays-acheteurs.json?001', function(data) {
			mapConfig.series.regions[0].values = data;
			$('#map-buyers').vectorMap(mapConfig);
		});

		let mapBuyersButton = document.querySelector('#button-map-1');
		let mapProductorsButton = document.querySelector('#button-map-2');
		let mapBuyers = document.querySelector('#map-buyers');
		let mapProductors = document.querySelector('#map-productors');

		mapBuyersButton.addEventListener( 'click', () => {
			mapBuyersButton.classList.add('is-active');
			mapProductorsButton.classList.remove('is-active');
			mapBuyers.classList.remove('is-hidden');
			mapProductors.classList.add('is-hidden');
		});

		mapProductorsButton.addEventListener( 'click', () => {
			mapProductorsButton.classList.add('is-active');
			mapBuyersButton.classList.remove('is-active');
			mapProductors.classList.remove('is-hidden');
			mapBuyers.classList.add('is-hidden');
		});
	}
}

export {Maps}
